/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class CustomerOverviewVO extends JSONable {
  uuid: string | undefined = undefined;
  customerName: string | undefined = undefined;
  country: string | undefined = undefined;
  customerLastContactDate: string | undefined = undefined;
  customerCreditStatus: string | undefined = undefined;
  customerLoyaltyCode: string | undefined = undefined;
  customerStage: string | undefined = undefined;
  newCustomer: boolean | undefined = undefined;
  creditLimit: number | undefined = undefined;
  billingCycle: string | undefined = undefined;
  paymentTerms: string | undefined = undefined;
  nextContactDate: string | undefined = undefined;
  opportunityPotentialGrossProfit: number | undefined = undefined;
  opportunityCommitedGrossProfit: number | undefined = undefined;
  totalPotentialGrossProfitPerYear: number | undefined = undefined;
  salesTeam: string | undefined = undefined;
  dso: number | undefined = undefined;
  actualPaymentTerm: string | undefined = undefined;
}
